export default __webpack_public_path__ + "static/media/play-button-blue.b09a194f.svg";